import * as React from 'react';
import { PonderaModal } from '../../components/inclinationmodals';
import './InclinationGroup.css';
import { ReportType, InclinationType } from '../../enums';

interface Inclination {
    name: string;
    helpText: string;
    tooltip: string;
    inclinationType: InclinationType;
    value: number;
    midrangeLow: number;
    midrangeHigh: number;
}

interface InclinationGroupProps {
    groupData: {
        name: string;
        subtitle: string;
        description: string;
        data: Inclination[];
    };
    reportType: ReportType;
}

interface InclinationGroupState {
    visible: boolean;
    modalVisible: boolean[];
}

export class InclinationGroup extends React.Component<InclinationGroupProps, InclinationGroupState> {
    constructor(props: InclinationGroupProps) {
        super(props);

        this.state = {
            visible: false,
            modalVisible: [false]
        };
    }

    toggleModal(index: number) {
        let { modalVisible } = this.state;

        modalVisible[index] = !modalVisible[index];
        this.setState({ modalVisible: modalVisible });
    }

    getModalElement(inclinationType: string, name: string, content: string, index: number) {
        const props = {
            show: this.state.modalVisible[index],
            onHide: this.toggleModal.bind(this, index),
            title: name,
            content: content
        };

        return <PonderaModal {...props} />;
    }

    render() {
        const { groupData, reportType } = this.props;

        let modals: any[] = [];

        return (
            <div>
                <div>
                    <div className="inclination-table">
                        <div className="row">
                            <div className="col-xs-6 col-md-4 col-lg-3">
                                <div className="cell" />
                                {
                                    groupData.data.map((item, index) => {
                                        modals.push(this.getModalElement(item.inclinationType.toString(), item.name, item.helpText, index));

                                        return <div className="cell text-right" key={`grid-cell-${index}`}>
                                            <span>{item.name}</span>
                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                        <span onClick={this.toggleModal.bind(this, index)} className="glyphicon glyphicon-info-sign icon-button" />
                                        </div>;
                                    })
                                }
                            </div>
                            <div className="col-xs-6 col-md-8 col-lg-9">
                                <div className="bg" />
                                <div className="cell">
                                    <div className="row">
                                        <div className="col-xs-6 text-left">
                                            <div className="cell">
                                                <span className="chart-content" style={{ left: -5 }}>Less Pronounced</span>
                                            </div>
                                        </div>
                                        <div className="col-xs-6 text-right">
                                            <div className="cell">
                                                <span className="chart-content" style={{ right: 0 }}>More Pronounced</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    groupData.data.map((item, index) => {
                                        let chart;
                                        if (reportType === ReportType.Midrange) {
                                            // chart = <InclinationMidrangeChart value={item.value} midrangeLow={item.midrangeLow} midrangeHigh={item.midrangeHigh} />;
                                        } else {
                                            chart = <div className="pva-bar-chart-bar" style={{ width: `${item.value}%` }}>
                                                <span>{Math.round(item.value)}</span>
                                            </div>;
                                        }
                                        return <div className="cell" key={`grid-chart-${index}`}>
                                            {chart}
                                        </div>;
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>

                {modals}
            </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/charts/InclinationGroup.tsx